import { createAction, props } from '@ngrx/store';
import {
  IAnswer,
  IAnswerSchema,
  MarkStatus,
  Questionnaire,
  SMEQC
} from '../models';


export const noop = createAction('[Questionnaire] Noop');

// Add a new 'add-more' type question to the questionnaire
export const addQuestion = createAction(
  '[Questionnaire] Add Question',
  props<{ questionId: string; subModuleId: string }>(),
);

// Remove an 'add-more' type question from the questionnaire
export const removeQuestion = createAction(
  '[Questionnaire] Remove Question',
  props<{ questionId: string; subModuleId: string; orderNumber: number }>(),
);

export const storeActiveQuestionnaireId = createAction(
  '[Questionnaire] Store Questionnaire Id',
  props<{ id: string }>(),
);

export const loadingQuestionnaire = createAction(
  '[Questionnaire] Loading Questionnaire',
  props<{ compositeKey: string }>(),
);

export const clearQuestionnaire = createAction('[Questionnaire] Clear');

export const storeQuestionnaire = createAction(
  '[Questionnaire] Store Questionnaire',
  props<{ questionnaire: Questionnaire }>(),
);

export const storeQuestionDict = createAction(
  '[Questionnaire] Store Question Dict',
  props<{
    questionDict: {
      [key: string]: { title: string; type: string; data?: any };
    };
  }>(),
);

export const updateAnswerThroughSocket = createAction(
  '[Questionnaire] Update Answer Through Socket',
  props<{ answer: IAnswerSchema }>(),
);

export const setActiveSectionOfQuestionnaire = createAction(
  '[Questionnaire] Set active Section Of Questionnaire ',
  props<{ index: number }>(),
);

export const getSectionOfQuestionnaireByName = createAction(
  '[Questionnaire] Get Section Of Questionnaire By Name',
  props<{ title: string }>(),
);

export const clearActiveSectionOfQuestionnaire = createAction(
  '[Questionnaire] Clear active Section Of Questionnaire',
);

export const setAnswer = createAction(
  '[Questionnaire] Set Answer',
  props<{ answer: any; mark?: SMEQC }>(),
);

export const savingAnswerMark = createAction(
  '[Questionnaire] Saving Answer Mark',
  props<{ answerId: string; mark: SMEQC }>(),
);

export const saveAnswerMarkSuccess = createAction(
  '[Questionnaire] Saving Answer Mark Success',
  props<{ answer: IAnswer; mark: SMEQC }>(),
);

export const saveAnswerMarkError = createAction(
  '[Questionnaire] Saving Answer Mark Error',
  props<{ answerId: string; mark: SMEQC }>(),
);

export const savingModuleMarkError = createAction(
  '[Questionnaire] Saving Module Mark Error',
  props<{ moduleId: string; mark: SMEQC }>(),
);

export const savingModuleMark = createAction(
  '[Questionnaire] Saving Module Mark',
  props<{ moduleId: string; mark: SMEQC }>(),
);

export const markModule = createAction(
  '[Questionnaire] Mark Module',
  props<{ module: any; status: MarkStatus; mark?: SMEQC }>(),
);

export const markModuleSuccess = createAction(
  '[Questionnaire] Mark Module Success',
  props<{ module: any }>(),
);

export const markModuleFailure = createAction(
  '[Questionnaire] Mark Module Failure',
  props<{ error: any }>(),
);
